import React from 'react';
import { CheckCircle } from 'lucide-react';
import { STEPS } from './setupConstants';

export const StepIndicator = ({ current }) => (
  <div className="flex items-center mb-8 gap-2">
    {STEPS.map((label, i) => (
      <React.Fragment key={label}>
        <div className="flex items-center gap-2">
          <div className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold transition-all ${
            i < current
              ? 'bg-teal-500 text-white'
              : i === current
                ? 'bg-white/10 text-white border border-teal-500'
                : 'bg-white/5 text-white/20'
          }`}>
            {i < current ? <CheckCircle className="w-4 h-4" /> : i + 1}
          </div>
          <span className={`text-xs hidden sm:block ${i === current ? 'text-white' : 'text-white/20'}`}>
            {label}
          </span>
        </div>
        {i < STEPS.length - 1 && (
          <div className={`flex-1 h-px ${i < current ? 'bg-teal-500/50' : 'bg-white/10'}`} />
        )}
      </React.Fragment>
    ))}
  </div>
);
